(() => {
    if (window.Sbh26RuntimeLoaded) return;
    window.Sbh26RuntimeLoaded = true;
    const unlockLayout = (main) => {
      main.style.setProperty('height', 'auto', 'important');
      main.style.setProperty('min-height', '0', 'important');
      [...main.querySelectorAll("[class*='section-sbh26-'], .section-senix-blue-homepage-2026")].forEach((element) => {
        if (!(element instanceof HTMLElement)) return;
        element.style.setProperty('height', 'auto', 'important');
        element.style.setProperty('min-height', '0', 'important');
      });
      main.style.setProperty('overflow', 'visible', 'important');
    };

    const initialize = (scope) => {
      const main = document.querySelector('#MainContent');
      if (main && main.dataset.sbhFlowReady !== 'true') {
        let flowFrame;
        const normalize = () => {
          cancelAnimationFrame(flowFrame);
          flowFrame = requestAnimationFrame(() => unlockLayout(main));
        };
        new MutationObserver(normalize).observe(main, { attributes: true, attributeFilter: ['style'], subtree: true });
        main.dataset.sbhFlowReady = 'true';
        normalize();
        [100, 500, 1500, 3000].forEach((delay) => window.setTimeout(normalize, delay));
      }

      scope.querySelectorAll('[data-sbh-bundle-add]').forEach((button) => {
        if (button.dataset.sbhBundleReady === 'true') return;
        button.dataset.sbhBundleReady = 'true';
        button.addEventListener('click', async () => {
          const row = button.closest('.sbh__kit-row');
          const status = row.querySelector('.sbh__bundle-status');
          const items = [...row.querySelectorAll('.sbh__kit-product[data-variant-id]')]
            .filter((card) => card.dataset.available !== 'false')
            .map((card) => ({ id: Number(card.dataset.variantId), quantity: 1 }))
            .filter((item) => Number.isFinite(item.id));
          if (!items.length) {
            status.textContent = 'Select available products for this bundle.';
            return;
          }
          button.disabled = true;
          status.textContent = 'Adding bundle…';
          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items })
            });
            if (!response.ok) throw new Error('Cart request failed');
            status.textContent = `${items.length} products added to cart.`;
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          } catch (error) {
            status.textContent = 'Unable to add this bundle. Please try again.';
          } finally {
            button.disabled = false;
          }
        });
      });

    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document));
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
